// Definición del componente web CartDiscount
class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }
  
  connectedCallback() {
    this.render();
    this.bindEvents();
    this.initDiscountTags();
  }
  
  render() {
    this.shadowRoot.innerHTML = `
      <style>
        /* Estilos para el campo de descuento */
        .cart__discount {
          margin-top: 15px;
          margin-bottom: 10px;
        }
        
        .discount-form .field {
          display: flex;
          max-width: 100%;
          border: 1px solid #000;
          border-radius: 3px;
          overflow: hidden;
          height: 54px
        }
        
        .discount-field {
          flex-grow: 1;
          border: none;
          border-radius: 0;
          height: 54px;
          box-shadow: none;
          padding-left: 15px;
          font-family: "Arial";
          font-size: 14px;
          letter-spacing: 0px;
        }

        .discount-field::placeholder {
          color: #d9d9d9;
        }
        
        .discount-field:focus {
          outline: none;
          box-shadow: none;
          border-color: red
        }
        
        .apply-button {
          background-color: #000;
          color: #fff;
          padding: 0;
          border: none;
          border-radius: 0;
          cursor: pointer;
          height: 54px;
          width: 52px;
          font-family: "Arial";
          font-size: 14px;
          letter-spacing: 0px;
        }
        
        .apply-button:hover {
          background-color: #333;
        }
        
        .discount-tags-container {
          margin: 10px 0;
        }
        
        .discount-tag {
          display: inline-flex;
          align-items: center;
          background-color: #f3f3f3;
          border: 1px solid #d9d9d9;
          border-radius: 3px;
          padding: 6px 10px;
          margin: 5px 0;
          font-size: 0.9em;
        }
        
        .discount-remove {
          background: none;
          border: none;
          margin-left: 8px;
          cursor: pointer;
          font-size: 16px;
          color: #666;
          padding: 0 5px;
        }
        
        .discount-remove:hover {
          color: #000;
        }
        
        .discount-status {
          text-align: center;
          margin-top: 5px;
        }
      </style>
      
      <div class="cart__discount">
        <div class="discount-form">
          <div class="field">
            <input
              class="discount-field"
              type="text"
              id="discount-code-input"
              name="discount"
              placeholder="Discount Code or Gift Card"
              aria-label="Discount code or gift card"
              autocomplete="off"
            >
            <button 
              class="apply-button"
              type="button"
              id="apply-discount-button"
            >
              Apply
            </button>
          </div>
        </div>
        <div class="discount-tags-container"></div>
        <div class="discount-status"></div>
      </div>
    `;
  }
  
  bindEvents() {
    // Conectar eventos a los elementos
    const applyButton = this.shadowRoot.getElementById('apply-discount-button');
    if (applyButton) {
      applyButton.addEventListener('click', () => this.applyCartDiscountCode());
    }
  }
  
  applyCartDiscountCode() {
    const codeInput = this.shadowRoot.getElementById('discount-code-input');
    const statusDiv = this.shadowRoot.querySelector('.discount-status');
    const discountCode = codeInput.value.trim();
    
    if (!discountCode) {
      codeInput.value = '';
      statusDiv.innerHTML = '';
      return;
    }
    
    const appliedCode = discountCode;
    codeInput.value = '';
    
    statusDiv.innerHTML = '<p>Applying discount code...</p>';
    
    let discountApplied = false;
    
    const timeoutId = setTimeout(() => {
      if (!discountApplied) {
        statusDiv.innerHTML = '';
      }
    }, 3000);
    
    fetch('/discount/' + encodeURIComponent(appliedCode))
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        
        return fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            discountApplied = true; 
            clearTimeout(timeoutId); 
            
            this.updateCartDisplay(cart);
          });
      })
      .catch(error => {
        console.error('Error applying discount:', error);
        setTimeout(() => {
          statusDiv.innerHTML = '';
        }, 1500);
      });
  }
  
  removeDiscount() {
    const statusDiv = this.shadowRoot.querySelector('.discount-status');
    statusDiv.innerHTML = '<p>Removing discount...</p>';
    
    fetch('/discount/clear', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => {
      return fetch('/cart.js') 
        .then(res => res.json())
        .then(cart => {
          this.updateCartDisplay(cart);
        });
    })
    .catch(error => {
      console.error('Error removing discount:', error);
      statusDiv.innerHTML = '';
    });
  }
  
  updateCartDisplay(cart) {
    const statusDiv = this.shadowRoot.querySelector('.discount-status');
    statusDiv.innerHTML = '';
    
    const discountTagsContainer = this.shadowRoot.querySelector('.discount-tags-container');
    if (discountTagsContainer) {
      discountTagsContainer.innerHTML = '';
    }
    
    fetch('/?section_id=cart-drawer')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        const subtotalElement = document.querySelector('.totals__subtotal-value');
        const newSubtotalElement = doc.querySelector('.totals__subtotal-value');
        if (subtotalElement && newSubtotalElement) {
          subtotalElement.textContent = newSubtotalElement.textContent;
        }
        
        // Update the total price with the discount
        this.updateTotalPrice(cart);
        
        // Update the discount block in the footer of the cart
        this.updateDiscountBlock(cart);
        
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
        
        if (cart.total_discount > 0 && cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
          let discountTags = '';
          
          cart.cart_level_discount_applications.forEach(discount => {
            const discountCode = discount.title;
            discountTags += `
              <div class="discount-tag">
                ${discountCode} <button type="button" class="discount-remove">&times;</button>
              </div>
            `;
          });
          
          discountTagsContainer.innerHTML = discountTags;
          
          const removeButtons = discountTagsContainer.querySelectorAll('.discount-remove');
          removeButtons.forEach(button => {
            button.addEventListener('click', () => this.removeDiscount());
          });
        }
      });
  }
  
  // Function to update the total price with the discount
  updateTotalPrice(cart) {
    const totalValueElement = document.querySelector('.totals__total-value');
    if (!totalValueElement) return;
    
    const moneySpan = totalValueElement.querySelector('.money');
    if (!moneySpan) return;
    
    const totalCents = cart.total_price;
    const discountCents = cart.total_discount;
    const finalTotalCents = totalCents;
     
    const formattedPrice = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(finalTotalCents / 100);
    
    moneySpan.textContent = formattedPrice;
  }
  
  // Function to update the discount block in the cart drawer
  updateDiscountBlock(cart) {
    // Find the container for the discount block
    const discountsContainer = document.querySelector('.cart-drawer__footer > div > ul.discounts');
    const discountsParent = document.querySelector('.cart-drawer__footer > div');
    
    if (!discountsParent) return;
    
   
    if (discountsContainer) {
      discountsContainer.remove();
    }
    
    if (cart.total_discount > 0 && cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
      const discountsList = document.createElement('ul');
      discountsList.className = 'discounts list-unstyled';
      discountsList.setAttribute('role', 'list');
      discountsList.setAttribute('aria-label', 'Discount');
      
      cart.cart_level_discount_applications.forEach(discount => {
        const discountAmount = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD'
        }).format(discount.total_allocated_amount / 100);
        
        const discountItem = document.createElement('li');
        discountItem.className = 'discounts__discount discounts__discount--end';
        
        discountItem.textContent = `${discount.title} (-${discountAmount})`;
        
        discountsList.appendChild(discountItem);
      });
      
      discountsParent.appendChild(discountsList);
    }
  }
  
  initDiscountTags() {

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        this.updateDiscountBlock(cart);
        
        if (cart.total_discount > 0 && cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
          let discountTags = '';
          
          cart.cart_level_discount_applications.forEach(discount => {
            const discountCode = discount.title;
            
            discountTags += `
              <div class="discount-tag">
                ${discountCode} <button type="button" class="discount-remove">&times;</button>
              </div>
            `;
          });
          
          const discountTagsContainer = this.shadowRoot.querySelector('.discount-tags-container');
          if (discountTagsContainer) {
            discountTagsContainer.innerHTML = discountTags;
            
            // Agregar event listeners a los botones de eliminar
            const removeButtons = discountTagsContainer.querySelectorAll('.discount-remove');
            removeButtons.forEach(button => {
              button.addEventListener('click', () => this.removeDiscount());
            });
          }
        } else {
          console.log('not exist discount applying to cart');
        }
      })
      .catch(error => {
        console.error('Error al inicializar etiquetas de descuento:', error);
      });
  }
}


customElements.define('cart-discount', CartDiscount);
/*
document.addEventListener('cart:updated', () => {
  const discountComponent = document.querySelector('cart-discount');
  if (discountComponent) {
    discountComponent.initDiscountTags();
  }
});

document.addEventListener('cart:refresh', () => {
  const discountComponent = document.querySelector('cart-discount');
  if (discountComponent) {
    discountComponent.initDiscountTags();
  }
});
*/